import { Popover, Transition } from "@headlessui/react";
import { Fragment } from "react";
// import SwitchDarkMode2 from "shared/SwitchDarkMode/SwitchDarkMode2";

import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { notificationsDummyData } from "contains/contants";

export default function NotificationsDropDown() {
  return (
    <div className="AvatarDropdown ">
      <Popover className="relative">
        {({ open, close }) => (
          <>
            <Popover.Button
              className={` focus:outline-none flex items-center justify-center`}
            >
              <NotificationsNoneIcon />
            </Popover.Button>
            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <Popover.Panel className="absolute z-10 w-screen max-w-[260px] px-4 mt-3.5 -right-10 sm:right-0 sm:px-0">
                <div className="overflow-hidden rounded-3xl shadow-lg ring-1 ring-black ring-opacity-5">
                  <div className="relative grid grid-cols-1  bg-white dark:bg-neutral-800 p-2">
                    {notificationsDummyData.map((va) => {
                      return (
                        <div className="NotificationsCard dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 text-slate-700">
                          <div className="Img" />
                          <div className="txtContainer">
                            <div className="TtlContainer">
                              <span className="userName">{va.from}</span>
                              <span>{va.date}</span>
                            </div>
                            <span className="descTxt">{va.txt}</span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </div>
  );
}
